import Vue from 'vue'
import VueRouter from 'vue-router'

// 这里采用懒加载吧
const Blog = () => import('../views/Blog')
const Personal = () => import('../views/PersonalInfo')
const Detail = () => import('../views/BlogDetail')
const BlogContent = () => import('../components/content/BlogContent')
const WriteBlog = () => import('../views/WriteBlog')
const XlogDecoder = () => import('../views/XlogDecoder')
const LicenseOpenId = () => import('../views/LicenseOpenId')
const DeviceActivation = () => import('../views/DeviceActivation')

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: '/blog'
  },
  {
    path: '/blog',
    component: Blog,
    redirect: '/blog/blogContent',
    children: [
      {
        path: 'blogContent',
        component: BlogContent
      },
      {
        path: 'personal',
        component: Personal
      }
    ]
  },
  {
    path: '/detail/:id',
    component: Detail
  },
  {
    path: '/writeblog',
    name: 'WriteBlog',
    component: WriteBlog
  },
  {
    path: '/xlog-decoder',
    name: 'XlogDecoder',
    component: XlogDecoder
  },
  {
    path: '/license-openid',
    name: 'LicenseOpenId',
    component: LicenseOpenId
  },
  {
    path: '/after-sale-activation',
    name: 'DeviceActivation',
    component: DeviceActivation
  }
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 返回保存的滚动位置（浏览器前进/后退时触发）
      return savedPosition;
    } else {
      // 跳转到新页面时滚动到顶部
      return { x: 0, y: 0 };
    }
  },
})

export default router
